import { Card } from 'antd';
import { useEffect, useState } from 'react';
import useGraficaAPI from '../../dashboard/EstadisticasApi/useGraficaAPI';


const Encabezado = () => {
  const [cardDatos, setCardDatos] = useState([{title:'', value: 0, description: ''}]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const api = useGraficaAPI();


  const cardData = [
    {
      title: 'Generadas',
      value: 0,
      description: 'Infracciones creadas'
    },
    {
      title: 'Pagadas',
      value: 0,
      description: 'Infracciones pagas'
    },
    {
      title: 'Por generar',
      value: 0,
      description: 'Listas para generar'
    }
  ];

  useEffect(() => {
    // Función para obtener datos de la API
    const fetchData = async () => {
      try {
        setLoading(true);
        // Reemplaza esta URL con tu endpoint real
        const response = await api.getHomeDataEncabezado();
        
        if (!response) {
          throw new Error('Error al obtener los datos');
        }
        
        const data = response.data?.value;
        
        // Transforma los datos según la estructura esperada
        // Ajusta esta parte según la estructura de tu API
        const transformedData = [
          {
            title: 'Generadas',
            value: data?.generadas ?? 0,
            description: 'Infracciones creadas'
          },
          {
            title: 'Pagadas',
            value: data?.pagadas ?? 0,
            description: 'Infracciones pagas'
          },
          {
            title: 'Por generar',
            value: data?.porGenerar ?? 0,
            description: 'Listas para generar'
          }
        ];
        
        setCardDatos(transformedData);
        setLoading(false);
      } catch (err) {
        setCardDatos(cardData);
        //console.log(err)
        setLoading(false);
      }
    };

    fetchData();
  }, []); // El array vacío asegura que se ejecute solo al montar el componente

  const formatoSinDecimal = (cantidad: number) => {
    const cantidadFormateada = new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: 0,   
      maximumFractionDigits: 0, 
    }).format(cantidad);
    
    return cantidadFormateada;
  };


  return (
    <div style={{
      backgroundColor: '#f0f0f0',
    //   padding: '40px 20px',
      minHeight: '300px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <div style={{
        display: 'flex',
        gap: '20px',
        flexWrap: 'wrap',
        justifyContent: 'center',
        // maxWidth: '1200px'
      }}>
        {cardDatos.map((card, index) => (
          <Card
            key={index}
            title={
              <span style={{
                textAlign: 'center'
              }}>
                {card.title}
              </span>
            }
            style={{
              width: 300,
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
          >
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <p style={{
                fontSize: '32px',
                fontWeight: 'bold',
                margin: '0 0 8px 0',
                color: '#1890ff'
              }}>
                {formatoSinDecimal(card.value)}
              </p>
              <p style={{
                fontSize: '14px',
                color: '#666',
                margin: 0
              }}>
                {card.description}
              </p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Encabezado;